// ============================================
// App Module - Index (ES6 Entry Point)
// ============================================
// 점진적 마이그레이션 중: 상태 변수는 app.js에 유지됨
// 이 모듈은 유틸리티 함수 제공

// State utilities
import {
  getCurrentUser,
  refreshChatUserMarkers,
  updateFixedMetaBar,
  getDb
} from './state.js';

// Display functions
import {
  hideSplashScreen,
  showSplashAsLogin,
  showApp
} from './display.js';

// Navigation functions
import {
  switchTab,
  getCurrentTab,
  setCurrentTab
} from './navigation.js';

// Keyboard handling
import {
  initKeyboardHandling,
  initMessageInputListener
} from './keyboard.js';

// ============================================
// 초기화
// ============================================

function init() {
  console.log('[AppModule] ES6 모듈 초기화');
}

// ============================================
// 모듈 초기화
// ============================================

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}

// ============================================
// Public API
// ============================================

const AppModule = {
  // 유틸리티 함수
  getCurrentUser,
  refreshChatUserMarkers,
  updateFixedMetaBar,
  getDb,
  // 디스플레이 함수
  hideSplashScreen,
  showSplashAsLogin,
  showApp,
  // 네비게이션 함수
  switchTab,
  getCurrentTab,
  setCurrentTab,
  // 키보드 함수
  initKeyboardHandling,
  initMessageInputListener
};

// 전역 노출 (기존 코드 호환성)
window.AppModule = AppModule;

export default AppModule;
